var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"base-link"},[(!_vm.isExternal)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.to,"target":"_blank"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }